const purgeKey = "rs.legacyCookiesPurged";

if (localStorage.getItem(purgeKey) !== "true") {
  if (document.cookie) {
    document.cookie.split(";").forEach((entry) => {
      const name = entry.split("=")[0]?.trim();
      if (name) {
        document.cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
    });
  }

  localStorage.setItem(purgeKey, "true");
}
